export const getInspectionCreateLink = (record, returnTo) => {
    const dueTypes = [
        record.vdeInspectionDue ? "vde" : null,
        record.uvvInspectionDue ? "uvv" : null,
    ].filter(Boolean);

    const params = new URLSearchParams({
        sku: record.id,
        returnTo,
    });

    if (dueTypes.length === 1) {
        params.set("type", dueTypes[0]);
    }

    return `#/skuInspections/create?${params.toString()}`;
};
